// Mints a one-time handoff code from the legacy backend and hard-redirects
// the browser to the enhanced portal's /sso screen. Clears the legacy session
// first so no stale tokens remain on the legacy origin.
export const redirectToEnhancedPortal = async ({ baseUrl, enhancedPortalUrl, next }) => {
  if (!enhancedPortalUrl) {
    // No target configured; fail safe by staying on the legacy portal.
    return false;
  }
  const accessToken = localStorage.getItem("accessToken");
  let response;
  try {
    response = await fetch(`${baseUrl}/auth/handoff-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch (error) {
    // Network error minting the handoff code; fail safe by staying on the legacy portal.
    return false;
  }
  if (!response.ok || response.status !== 201) {
    return false;
  }
  const { code } = await response.json();
  const anonymousKey = localStorage.getItem("anonymousKeyForLD");
  localStorage.clear();
  if (anonymousKey && anonymousKey !== "null") localStorage.setItem("anonymousKeyForLD", anonymousKey);
  const nextParam = next ? `&next=${encodeURIComponent(next)}` : "";
  window.location.href = `${enhancedPortalUrl}/sso?code=${code}${nextParam}`;
  return true;
};

// True when the app is currently running AT the enhanced-portal origin
// (so it must NOT redirect to itself). Compares the running origin to the
// configured ENHANCED_PORTAL_URL. Returns false on missing/invalid URL.
export const isRunningAsEnhancedPortal = (enhancedPortalUrl) => {
  try {
    return !!enhancedPortalUrl && new URL(enhancedPortalUrl).origin === window.location.origin;
  } catch (e) {
    return false;
  }
};
